export default "__VITE_ASSET__9617f514__"